export enum EExpandingSymbolAnimations {
    SYMBOL_EXPANDING = 'SYMBOL_EXPANDING',
    SYMBOL_EXPANDING_WIN = 'SYMBOL_EXPANDING_WIN'
}

export enum EExpandingSymbolAnimationModifiers {
    MULTIPLIER = '_X_$',
    REEL = '_REEL_$',
    ROW = '_ROW_$',
    DIMENSIONS = '_$X$'
}
